import { CheckoutView } from './CheckoutView';
import type { PublicCheckout } from './contract';
import type { CheckoutTrackingIdentifiers, CheckoutUtmAttribution } from './attribution';

export function CheckoutLegacySkin(props: {
  checkout: PublicCheckout;
  preview?: boolean;
  affiliateRef?: string | undefined;
  utm?: CheckoutUtmAttribution | undefined;
  trackingIdentifiers?: CheckoutTrackingIdentifiers | undefined;
  recuperaaiCartId?: string | undefined;
  refreshCheckout?: (() => Promise<PublicCheckout>) | undefined;
  ensureCheckoutSession?: ((force?: boolean) => Promise<string | undefined>) | undefined;
  onActivity?: (() => void | Promise<unknown>) | undefined;
  onBusyChange?: ((busy: boolean) => void) | undefined;
}) {
  return <CheckoutView {...props} skin="legacy" />;
}
